const amaxPayXero = 'companies/:companyId/requests/:requestId/amax-pay/xero';

export const paymentServicesPaths = {
    openBankingPay: `${amaxPayXero}/open-banking/pay`,
    walletsPay: `${amaxPayXero}/virtual-accounts/pay`,
} as const;
